import React from "react";

const TableCell = ({ children, className = "" }) => (
  <td className={`tw-p-16px tw-overflow-ellipsis tw-whitespace-nowrap tw-overflow-hidden ${className}`}>
    {children}
  </td>
);

export default TableCell;
